export enum TableCode {
    Ticket,
    SubTask
}
